import React, { useState } from 'react';
import { UserListFilter } from '../types/UserList';

interface Props {
  filter: UserListFilter;
  onFilterChange: (filter: UserListFilter) => void;
}

export default function UserListToolbar({ filter, onFilterChange }: Props) {
  const [value, setValue] = useState(filter?.value || '');
  const field = filter?.field || '';

  const update = (nextField: '' | 'role' | 'email', nextValue = value) => {
    if (!nextField || !nextValue.trim()) onFilterChange(null);
    else onFilterChange({ field: nextField, value: nextValue.trim() });
  };

  return (
    <div className="d-flex gap-2 align-items-center flex-wrap" data-testid="user-list-toolbar">
      <select
        className="form-select form-select-sm"
        value={field}
        onChange={(event) => {
          const next = event.target.value as '' | 'role' | 'email';
          setValue('');
          update(next, '');
        }}
        aria-label="Filter users by"
      >
        <option value="">All users</option>
        <option value="role">Role</option>
        <option value="email">Email</option>
      </select>
      {field && (
        <>
          <input
            className="form-control form-control-sm"
            value={value}
            placeholder={field === 'role' ? 'Role' : 'Exact email'}
            onChange={(event) => setValue(event.target.value)}
            onKeyDown={(event) => {
              if (event.key === 'Enter') update(field, value);
            }}
            aria-label={field === 'role' ? 'Role filter' : 'Email filter'}
          />
          <button className="btn btn-sm btn-primary" onClick={() => update(field, value)}>
            Apply
          </button>
        </>
      )}
    </div>
  );
}
